import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import { collection, onSnapshot } from "firebase/firestore";
import { firestore } from "../../firebase";
import { useAuth } from "../Context";

/**
 * Select de vehículos por sucursal actual del contexto.
 * Props:
 *   value: id del vehículo seleccionado
 *   onChange: callback(idVehiculo)
 */
const VehiculosSelect = ({ value, onChange, placeholder = "Selecciona un vehículo" }) => {
  const { sucursal } = useAuth();
  const [vehiculos, setVehiculos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sucursal) return;
    setLoading(true);
    const q = collection(firestore, `sucursal/${sucursal}/vehiculos`);
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setVehiculos(data);
      setLoading(false);
    });
    return () => unsubscribe();
  }, [sucursal]);

  return (
    <Select
      showSearch
      allowClear
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      loading={loading}
      filterOption={(input, option) =>
        (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
      }
      style={{ width: "100%" }}
    >
      {vehiculos.map(vehiculo => (
        <Select.Option key={vehiculo.id} value={vehiculo.id}>
          {vehiculo.placa || vehiculo.nombre || vehiculo.id}
        </Select.Option>
      ))}
    </Select>
  );
};

export default VehiculosSelect;
